/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "PrintLabelPageService";
const log: any = LoggerModule.getInstance();

export class PrintLabelPageService {
  private static instance: PrintLabelPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): PrintLabelPageService {
    if (!PrintLabelPageService.instance) {
      PrintLabelPageService.instance = new PrintLabelPageService(props);
    }
    return PrintLabelPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPresentationLists() {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getPresentationLists();
    return content;
  }

  public async getLabelPDF(args: any) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getLabelPDF(args);
    return content;
  }

  public async addSerialNo(args: any) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.addSerialNo(args);
    return content;
  }
}
